import angular from 'angular';

const queryFormModule = angular.module('app.queryform', []);

export default queryFormModule.name;

queryFormModule.directive('queryInput', () => ({
  template: ` <div>
    <div class="field" ng-show="!justInput">
        <label for="" class="query-label">{{label}}</label>
        <div class="query-form-input">
            <input type="text" ng-model="model" class="form-control input-period" placeholder="{{inputPlaceholder}}">
        </div>
    </div>
    <input type="text" ng-model="model" class="form-control input-period" ng-show="justInput" ng-disabled="inputDisabled" ng-class="{'forbiden-btn-important':inputDisabled}">
</div>
    `,
  restrict: 'E',
  replace: true,
  scope: {
    label: '@',
    model: '=',
    type: '@',
    clearTime: '=',
    datePickerConfig: '<',
    justInput: '<',
    inputPlaceholder: '@',
    inputDisabled: '<',
  },
  link(scope, element) {
    if (scope.type === 'date') {
      const inputEle = element.find('input');
      inputEle.attr('readonly', true);
      // 日期表单去除记录行为 @author sujj
      inputEle.autocomplete = 'off';
      inputEle.datetimepicker(
        $.extend(
          {
            autoclose: true,
            minView: 'month', // 选择日期后，不会再跳转去选择时分秒
            language: 'zh-CN',
            format: 'yyyy-mm-dd',
            forceParse: 0,
            pickTime: false,
            pickerPosition: 'bottom-right',
            initialDate: scope.model, //弹出显示的时间
          },
          scope.datePickerConfig
        )
      );
      if (scope.model && scope.model.length > 7) {
        inputEle.datetimepicker('setDate', new Date(scope.model));
      }
      // 清空操作
      $('.clear').each(function (i) {
        $(this).click(function () {
          scope.model = '';
          // scope.clearTime && scope.clearTime(i)
        });
      });
      // 清空操作时会存在赋值为空 重新赋值
      inputEle.on('changeDate', (e) => {
        !scope.model && inputEle.datetimepicker('setDate', new Date(e.date));
      });
    }
  },
}));
queryFormModule.directive('querySelect', () => ({
  restrict: 'E',
  replace: true,
  template: `<div class="field">
        <label for="" class="query-label">{{label}}</label>
        <div class="query-form-input">
            <select class="form-control" ng-model="model" ng-change="selChange()">
            <option value="" ng-if="default">{{default}}</option>
            <option value="{{item[key]}}" ng-repeat="item in options">{{item[value]}}</option>
            </select>
        </div>
    </div>`,
  scope: {
    label: '@',
    model: '=',
    options: '<',
    key: '@',
    value: '@',
    default: '@',
    querySelectChange: '=',
  },
  link(scope) {
    scope.key = scope.key || 'enumCode';
    scope.value = scope.value || 'enumName';
    scope.selChange = () => {
      scope.querySelectChange && scope.querySelectChange(scope.model);
    };
  },
}));
queryFormModule.directive('queryTableSelect', () => ({
  restrict: 'E',
  replace: true,
  template: `
        <div class="query-form-input">
            <select class="form-control" ng-model="model" ng-change="selChange()">
            <option value="" ng-if="default">{{default}}</option>
            <option value="{{item[key]}}" ng-repeat="item in options">{{item[value]}}</option>
            </select>
        </div>`,
  scope: {
    model: '=',
    options: '<',
    key: '@',
    value: '@',
    default: '@',
    querySelectChange: '=',
  },
  link(scope) {
    scope.key = scope.key || 'enumCode';
    scope.value = scope.value || 'enumName';
    scope.selChange = () => {
      scope.querySelectChange && scope.querySelectChange(scope.model);
    };
  },
}));
queryFormModule.directive('queryPeriod', () => ({
  template: `<div class="field">
            <label for="" class="query-label">{{label}}</label>
            <div class="query-form-input">
                <span class="connect-arr">~</span>
                <div class="row">
                    <div class="col-sm-6">
                        <input type="text"  class="form-control input-period" ng-model="start">
                    </div>
                    <div class="col-sm-6">
                        <input type="text"  class="form-control input-period" ng-model="end">
                    </div>
                </div>
            </div>
        </div>`,
  restrict: 'E',
  replace: true,
  scope: {
    label: '@',
    start: '=',
    end: '=',
    type: '@',
    datePickerConfig: '<?', // 不考虑异步情况不添加watch
    specialFlag: '@', // 【发票勾选4.0】【ID1026118】当改变开始日期， 时间备选跨度不变
  },
  link(scope, element) {
    if (scope.type !== 'date') {
      return;
    }
    const pickerConfig = $.extend(
      {
        autoclose: true,
        minView: 'month', // 选择日期后，不会再跳转去选择时分秒
        language: 'zh-CN',
        format: 'yyyy-mm-dd',
        forceParse: 0,
        pickTime: false,
        pickerPosition: 'bottom-right',
      },
      scope.datePickerConfig
    );
    const startDateEle = $(element.find('input')[0]);
    const endDateEle = $(element.find('input')[1]);
    startDateEle.attr('readonly', true);
    endDateEle.attr('readonly', true);
    startDateEle.datetimepicker(pickerConfig).on('changeDate', (e) => {
      endDateEle.datetimepicker('setStartDate', e.target.value);
      !scope.specialFlag &&
        endDateEle.datetimepicker(
          'setEndDate',
          `${new Date(e.target.value).getFullYear() + 5}-${
            new Date(e.target.value).getMonth() + 1
          }-${new Date(e.target.value).getDate()}`
        );
      scope.start = e.target.value;
    });
    endDateEle.datetimepicker(pickerConfig).on('changeDate', (e) => {
      startDateEle.datetimepicker('setEndDate', e.target.value);
      startDateEle.datetimepicker(
        'setStartDate',
        `${new Date(e.target.value).getFullYear() - 5}-${
          new Date(e.target.value).getMonth() + 1
        }-${new Date(e.target.value).getDate()}`
      );
      scope.end = e.target.value;
    });
    scope.$watch('start', (newVal) => {
      endDateEle.datetimepicker('setStartDate', new Date(scope.start) || '');
    });
    scope.$watch('end', (newVal) => {
      !scope.specialFlag &&
        startDateEle.datetimepicker('setEndDate', new Date(scope.end) || '');
    });
    // 异步设置开始时间结束时间
    scope.$watch('datePickerConfig', (newVal) => {
      if (!newVal) {
        return;
      }
      const { startDate, endDate } = newVal;
      if (startDate) {
        startDateEle.datetimepicker('setStartDate', startDate);
        endDateEle.datetimepicker('setStartDate', startDate);
      }
      if (endDate) {
        startDateEle.datetimepicker('setEndDate', endDate);
        endDateEle.datetimepicker('setEndDate', endDate);
      }
    });
  },
}));
queryFormModule.directive('queryOrg', () => ({
  template: `
    <div class="field">
            <label for="" class="query-label" ng-if="label">{{label}}</label>
            <div class="query-form-input">
                <org-select orglist="list" org-change="orgChange" query-json="config"></org-select>
            </div>
        </div>`,
  scope: {
    label: '@',
    list: '<',
    config: '<',
    callback: '=',
  },
  link(scope) {
    scope.orgChange = (v) => {
      scope.callback && scope.callback(v);
    };
  },
}));
// 表头排序
queryFormModule.directive('querySort', () => ({
  restrict: 'EACM',
  replace: true,
  template: `<span class="sort-wrapper" ng-click="clickHandle($event)">
      <span>{{name}}</span>
      <span class="caret-wrapper"  ng-class="{'caret-active':orderMap.sortKey==sortName}">
        <i class="sort-caret ascending" ng-class="{'active-asc':orderMap.sortVal=='asc'}" sort="asc"></i>
        <i class="sort-caret descending" ng-class="{'active-desc':orderMap.sortVal=='desc'}" sort="desc"></i>
      </span>
  </span>`,
  scope: {
    orderMap: '=',
    sortName: '@',
    name: '@',
    sortHandle: '&',
  },
  controller: [
    '$scope',
    '$rootScope',
    'httpRequest',
    function ctrl($scope, $rootScope, httpRequest) {
      $scope.clickHandle = (e) => {
        if ($scope.orderMap.sortKey != $scope.sortName) {
          // 字段与上次不同，重置一下
          $scope.orderMap.sortVal = '';
          $scope.orderMap.sortKey = $scope.sortName;
        }
        if (e.target.nodeName == 'I') {
          // 点击上下按钮
          if ($scope.orderMap.sortVal == e.target.getAttribute('sort')) {
            // 与上次排序相同,变为无序
            $scope.orderMap.sortVal = '';
            $scope.orderMap.sortKey = '';
          } else {
            // 与上次排序不同，变为点击的排序
            $scope.orderMap.sortVal = e.target.getAttribute('sort');
          }
        } else {
          // 点击字段名（三种情况）
          if ($scope.orderMap.sortVal === 'asc') {
            // 升序->降序
            $scope.orderMap.sortVal = 'desc';
          } else if ($scope.orderMap.sortVal === 'desc') {
            // 降序->升序
            $scope.orderMap.sortVal = '';
            $scope.orderMap.sortKey = '';
          } else {
            // 无序->升序
            $scope.orderMap.sortVal = 'asc';
          }
        }
        if (window.currentProfileType) {
          httpRequest
            .get_getUserCustomized(window.currentProfileType)
            .then((res) => {
              if (res.data.value) {
                const saveConfig = JSON.parse(res.data.value);
                saveConfig.orderMap = $scope.orderMap;
                httpRequest.post_saveUserCustomized({
                  profileInfo: JSON.stringify(saveConfig),
                  profileType: window.currentProfileType,
                });
              } else {
                const saveConfig = {};
                saveConfig.orderMap = $scope.orderMap;
                httpRequest.post_saveUserCustomized({
                  profileInfo: JSON.stringify(saveConfig),
                  profileType: window.currentProfileType,
                });
              }
            });
        }
        $scope.sortHandle && $scope.sortHandle();
      };
    },
  ],
}));
queryFormModule.directive('queryInputTime', () => ({
  template: ` <div>
    <div class="field" ng-show="!justInput">
        <label for="" class="query-label">{{label}}</label>
        <div class="query-form-input" ng-mouseenter="inputMouseenter()" ng-mouseleave="inputMouseleave()" id="queryInputTime">
            <input type="text" ng-model="model" class="input-period" placeholder="{{inputPlaceholder}}">
        </div>
    </div>
    <input type="text" ng-model="model" class="form-control input-period" ng-show="justInput" ng-change="action()" ng-disabled="inputDisabled" ng-class="{'forbiden-btn-important':inputDisabled}">
</div>
    `,
  restrict: 'E',
  replace: true,
  scope: {
    label: '@',
    model: '=',
    type: '@',
    datePickerConfig: '<',
    justInput: '<',
    inputPlaceholder: '@',
    inputDisabled: '<',
    action: '&',
  },
  link(scope, element) {
    if (scope.type === 'date') {
      const inputEle = element.find('input');
      inputEle.attr('readonly', true);
      // 日期表单去除记录行为 @author sujj
      inputEle.autocomplete = 'off';
      inputEle.datetimepicker(
        $.extend(
          {
            autoclose: true,
            startView: 'year', //只能选择月份
            minView: 'year', // 选择日期后，不会再跳转去选择时分秒
            language: 'zh-CN',
            format: 'yyyy-mm',
            forceParse: 0,
            pickTime: false,
            initialDate: scope.model, //弹出显示的时间
            pickerPosition: 'bottom-right',
          },
          scope.datePickerConfig
        )
      );
      inputEle.on('changeDate', function () {
        if (scope.action) scope.action();
      });
      if (scope.model && scope.model.length > 7) {
        inputEle.datetimepicker('setDate', new Date(scope.model));
      }
    }
    scope.hover = false;
    scope.inputMouseenter = function () {
      scope.hover = true;
    };
    scope.inputMouseleave = function () {
      scope.hover = false;
    };
    scope.clearDate = function () {
      scope.model = '';
    };
  },
}));
queryFormModule.directive('queryInputQuarter', () => ({
  template: ` <div>
    <div class="field" ng-show="!justInput">
        <label for="" class="query-label" ng-show="label">{{label}}</label>
        <div class="query-form-input" ng-mouseenter="inputMouseenter()" ng-mouseleave="inputMouseleave()" id="queryInputQuarter">
            <input type="text" ng-model="model" class="input-period" placeholder="{{inputPlaceholder}}">
        </div>
    </div>
    <input type="text" ng-model="model" class="form-control input-period" ng-show="justInput" ng-change="action()" ng-disabled="inputDisabled" ng-class="{'forbiden-btn-important':inputDisabled}">
</div>
    `,
  restrict: 'E',
  replace: true,
  scope: {
    label: '@',
    model: '=',
    type: '@',
    datePickerConfig: '<',
    justInput: '<',
    inputPlaceholder: '@',
    inputDisabled: '<',
    action: '&',
  },
  link(scope, element) {
    if (scope.type === 'quarter') {
      const inputEle = element.find('input');
      inputEle.attr('readonly', true);
      // 日期表单去除记录行为 @author sujj
      inputEle.autocomplete = 'off';
      $.fn.datetimepicker.dates['zh-CN-quarter'] = {
        days: [
          '星期日',
          '星期一',
          '星期二',
          '星期三',
          '星期四',
          '星期五',
          '星期六',
          '星期日',
        ],
        daysShort: [
          '周日',
          '周一',
          '周二',
          '周三',
          '周四',
          '周五',
          '周六',
          '周日',
        ],
        daysMin: ['日', '一', '二', '三', '四', '五', '六', '日'],
        // 月份改造成季度
        months: ['Q1', 'Q2', 'Q3', 'Q4'],
        monthsShort: ['一季度', '二季度', '三季度', '四季度'],
        // today: '今天',
        // clear: '清空', // 添加部分
        suffix: [],
        meridiem: ['上午', '下午'],
      };
      inputEle.datetimepicker(
        $.extend(
          {
            autoclose: true, //选择后关闭
            pickTime: false,
            pickerPosition: 'bottom-right',
            // startView: 3,
            minView: 3,
            forceParse: 0, //默认现在时间
            format: 'yyyy-MM',
            language: 'zh-CN-quarter',
            initialDate: scope.model, //弹出显示的时间
            // endDate: scope.model, //箭头
          },
          scope.datePickerConfig
        )
      );
      inputEle.on('changeDate', function () {
        if (scope.action) scope.action();
      });
      if (scope.model && scope.model.length > 7) {
        inputEle.datetimepicker('setDate', new Date(scope.model));
      }
    }
    scope.hover = false;
    scope.inputMouseenter = function () {
      scope.hover = true;
    };
    scope.inputMouseleave = function () {
      scope.hover = false;
    };
    scope.clearDate = function () {
      scope.model = '';
    };
  },
}));



// WEBPACK FOOTER //
// ./src/components/queryForm/index.js